import React, { useState, useEffect, useContext } from "react";
import { Box, Typography, Button } from "@mui/material";
import SelectInputField from "../../CommonComponents/SelectInputField";
import { userAccessService } from "../../../Restclient/datacollection";
import { ThemeContext } from "../../Homepage";
import { useSelector } from "react-redux";

const LoginPolicySettings = () => {
  const userdetails = useSelector((state) => state.logindata.userdetails)
  const { User_Role_ID, Organizationid, Projectlist } = useSelector(
    (state) => state.logindata.userdetails
  );

  const { theme } = useContext(ThemeContext);
  const [policyOptions, setPolicyOptions] = useState({});
  const [selectedOptions, setSelectedOptions] = useState(null); 

  const fetchLoginPolicySettings = async () => {
    try {
      const response = await userAccessService.getLoginPolicyOptions(User_Role_ID);

      if (response.success) {
        setPolicyOptions(response.data.data);
      } else {
        console.error("Failed to fetch login policy settings:", response.message);
      }
    } catch (error) {
      console.error("Error fetching login policy settings:", error);
    }
  };

  const fetchDefaultOptions = async () => {
    try {
      const response = await userAccessService.getLoginPolicySettings(
        Organizationid,
        Projectlist
      );

      if (response.success) {
        setSelectedOptions(response.data.data); 
      } else {
        console.error("Failed to fetch default login policy settings:", response.message);
      }
    } catch (error) {
      console.error("Error fetching default login policy settings:", error);
    }
  };

  useEffect(() => {
    fetchLoginPolicySettings();
    fetchDefaultOptions();
  }, []);

  const handleChange = (key, value) => {
    setSelectedOptions((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSave = async () => {
    const updatedObj = {
        policyobject:selectedOptions,
 createruserroleProjectID: ((userdetails?.User_Role_Details?.Name == "EA_ADMIN") || (userdetails?.User_Role_Details?.Name == "ORGANIZATION_ADMIN")) ? "All": userdetails?.Projectlist[0],
        createruserroleidOrganizationID: (userdetails?.User_Role_Details?.Name == "EA_ADMIN")? "All":Organizationid,
        createruserroleid:User_Role_ID
    }

    try {
      const response = await userAccessService.savePolicySettings(updatedObj);
      if (response.success) {
        alert("Settings saved successfully!");
      } else {
        alert("Failed to save settings.");
      }
    } catch (error) {
      console.error("Error saving login policy settings:", error);
      alert("An error occurred while saving settings.");
    }
  };

  // Helper to format option labels
const formatOptionLabel = (key, value) => {
  // Helper for pluralization
  const pluralize = (num, unit) => `${num} ${unit}${num !== 1 ? "s" : ""}`;

  // Convert seconds to human readable format
  const formatSeconds = (seconds) => {
    if (seconds === -1) return "never";
    if (seconds < 60) return pluralize(seconds, "sec");
    if (seconds < 3600) return pluralize(Math.round(seconds / 60), "min");
    if (seconds < 86400) return pluralize(Math.round(seconds / 3600), "hr");
    if (seconds % 86400 === 0) return pluralize(seconds / 86400, "day");
    if (seconds % 3600 === 0) return pluralize(seconds / 3600, "hr");
    if (seconds % 60 === 0) return pluralize(seconds / 60, "min");
    return `${seconds} sec`;
  };

  switch (key) {
    case "Login_Inactivity_Timeout":
      return formatSeconds(value);
    case "Invalid_Login_Attempts_Allowed":
    case "Previous_password_memory":
      return value;
    case "Invalid_Login_Lockout_Period":
      return formatSeconds(value);
    case "Password_expiration_duration":
      if (value < 86400) return formatSeconds(value);
      return pluralize(Math.round(value / 86400), "day");
    case "Password_expiration_warning":
      if (value < 86400) return formatSeconds(value);
      return pluralize(Math.round(value / 86400), "day");
    default:
      return value;
  }
};



  if (!selectedOptions || !policyOptions) {
    
    return (
      <Box sx={{ padding: "20px", textAlign: "center" }}>
        <Typography variant="h6">Loading...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ padding: "20px", maxWidth: "600px", margin: "0 10px" }}>
      <Typography
        variant="subtitle1"
        sx={{
          color: "#008CD7",
          fontWeight: "bold",
          marginBottom: "20px",
        }}
      >
        Login Policy Settings
      </Typography>
      {Object.keys(policyOptions).map((key) => (
        <Box key={key} sx={{}}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: "bold",
              backgroundColor: theme === "dark" ? "#252525" : "#ffffff",
              color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
            }}
          >
            {(() => {
              switch (key) {
                case "Login_Inactivity_Timeout": return "Inactivity Timeout";
                case "Invalid_Login_Attempts_Allowed": return "Invalid Login Attempts";
                case "Invalid_Login_Lockout_Period": return "Invalid Login Lockout Period";
                case "Password_expiration_duration": return "Password expiration duration";
                case "Password_expiration_warning": return "Password expiration warning";
                case "Previous_password_memory": return "Previous password memory";
                default: return key.replace(/_/g, " ");
              }
            })()}
          </Typography>
          <SelectInputField
            value={selectedOptions[key]}
            onChange={(e) => handleChange(key, e.target.value)}
            options={policyOptions[key].map((option) => ({
              value: option,
              label: formatOptionLabel(key, option),
            }))}
            style={{
              width: "50%",
              color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
            }}
          />
        </Box>
      ))}

    <button
      onClick={handleSave}
      style={{
        marginTop: "20px",
        backgroundColor: "rgb(0, 92, 142)",
        color: "white",
        borderRadius: "25px",
        padding: "10px 20px",
        fontSize: "16px",
        Width: "48px",
        height: "48px",
        Top: "909px",
        left: "864px"
      }}
    >
      Save Settings
    </button>
  </Box>
  );
};

export default LoginPolicySettings;